import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import { abbreviateNumber } from 'common/formatters';

import SrIcon from 'client/components/SrIcon';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrPartnerStatInfoModal from 'client/components/SrPartnerStatInfoModal';

import './SrPartnerStatCardV2.less';

const SrPartnerStatCardV2 = ({
  description,
  iconUrl,
  total,
  disabled,
  onClick,
  formatNumber,
  tooltipText,
}) => {
  const [showInfoModal, setShowInfoModal] = useState(false);
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrBox
      boxSizing="border-box"
      width="150px"
      height="152px"
      backgroundColor="white"
      padding="16px"
      borderRadius={isSmallScreen ? '14px' : '24px'}
      boxShadow="0px 5px 21px rgba(25, 51, 64, 0.05)"
      className={classnames({
        disabled: disabled,
        clickable: !!onClick,
      })}
      onClick={onClick}
      flexShrink="0"
    >
      <SrBox marginBottom="19px">
        <SrFlex justify="between" align="center">
          <SrBox
            width="24px"
            height="24px"
            backgroundSize="contain"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
            backgroundImage={`url(${iconUrl})`}
          />
          {tooltipText && (
            <SrBox onClick={() => setShowInfoModal(true)}>
              <SrIcon
                className="question-mark-circle-small-20"
                cursor="pointer"
                onClick={() => setShowInfoModal(true)}
              />
            </SrBox>
          )}
        </SrFlex>
      </SrBox>
      <SrBox marginBottom="11px">
        <SrText
          font="greycliff"
          size="36"
          lineHeight="43px"
          color="blueGreycliff"
          weight="800"
          display="block"
        >
          {disabled ? 'N/A' : formatNumber ? abbreviateNumber(total, 1) : total}
        </SrText>
      </SrBox>
      <SrText
        font="greycliff"
        color="blueGreycliff"
        size="16"
        lineHeight="24px"
        weight="600"
        opacity="0.5"
        display="block"
        whiteSpace="nowrap"
        letterSpacing="0px"
      >
        {description}
      </SrText>
      {showInfoModal && (
        <SrPartnerStatInfoModal
          onClose={() => setShowInfoModal(false)}
          text={tooltipText}
          title={description}
        />
      )}
    </SrBox>
  );
};

SrPartnerStatCardV2.propTypes = {
  description: PropTypes.string.isRequired,
  iconUrl: PropTypes.string.isRequired,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  formatNumber: PropTypes.bool,
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

SrPartnerStatCardV2.defaultProps = {
  formatNumber: true,
};

SrPartnerStatCardV2.displayName = 'SrPartnerStatCardV2';

export default SrPartnerStatCardV2;
